import {
  getOrders,
  getAccessValidation,
  prioritizeList,
  reanalysisList,
  prioritizeOrder,
  reanalyzeOrder,
  getFinalizationStatusList,
  finalizationByParam
} from '@/common/services/modules/orders-search'
import { cnpj, cpf } from '@/common/utils/documentMask.js'

const initialValueState = {
  isLoading: false,
  renderedItens: 0,
  isRedirected: false,
  codeToSearch: '',
  typeOfCode: '',
  error: false,
  noReturn: false,
  confirmationModal: false,
  currentPage: 1,
  pageQuantity: 30,
  widgetVisibility: false,
  actionColumnVisibility: false,
  reanalysisAuthorization: false,
  priorizationAuthorization: false,
  finalizationAuthorization: false,
  prioritiesList: [],
  reanalysisList: [],
  finalizationMenuList: [],
  prioritiesErrorList: {},

  reanalysisErrorList: {},
  reanalysisTypeId: 0,
  actionsListLoading: false,
  finalizationMenuLoading: false,
  finalizationStatusList: {},
  finalizationAllowence: false,
  finalizationStatusListLoading: false,
  finalizationStatusError: false,
  prioritiesError: false,
  reanalysisError: false,
  finalizationError: false,
  finalizationErrorMessage: {},
  actionModalError: false,
  actionSnackbar: false,
  actionSnackbarOption: '',
  actionModalVisibility: false,
  actionUpdate: false,
  info: {
    count: 0,
    orders: [
      {
        code: '',
        cpfCnpj: '',
        email: '',
        value: 0,
        status: '',
        score: 0,
        orderDate: Date,
        registerDate: Date
      }
    ]
  }
}

const configParameters = {
  orderBy: 0
}

export default {
  namespaced: true,
  state: initialValueState,
  mutations: {
    UPDATE_ORDERS(state, payload) {
      state.info = payload
    },
    UPDATE_ORDERS_BY_CODE(state, payload) {
      state.info.count = 1
      state.info.orders = payload
    },
    UPDATE_ERROR(state, payload) {
      state.error = payload
    },
    UPDATE_NO_RETURN(state, payload) {
      state.noReturn = payload
    },
    UPDATE_PAGE(state, payload) {
      state.currentPage = payload
    },
    RESET_STATE(state) {
      state = {
        isLoading: false,
        renderedItens: 0,
        isRedirected: false,
        codeToSearch: '',
        typeOfCode: '',
        error: false,
        noReturn: false,
        confirmationModal: false,
        currentPage: 1,
        info: {
          count: 0,
          orders: []
        }
      }
    },
    PREPARE_TO_CALL(state) {
      state = {
        ...state,
        error: false,
        noReturn: false,
        info: { ...initialValueState.info, orders: [], count: 0 }
      }
    },
    PREPARE_TO_CALL_FINALIZATION(state) {
      state = {
        ...state,
        finalizationMenuList: [],
        finalizationStatusList: {},
        finalizationStatusError: false,
        finalizationError: false,
        finalizationErrorMessage: {}
      }
    },
    TOGGLE_CONFIRMATION_MODAL(state, visibility) {
      state.confirmationModal = visibility
    },
    TOGGLE_ACTION_SNACKBAR(state) {
      state.actionSnackbar = true
      setTimeout(() => {
        state.actionSnackbar = false
      }, 5000)
    },
    UPDATE_SNACKBAR_ACTION(state, payload) {
      state.actionSnackbarOption = payload
    },
    UPDATE_CODE(state, payload) {
      state.codeToSearch = payload
    },
    UPDATE_PAGE_QUANTITY(state, payload) {
      state.pageQuantity = payload
    },
    UPDATE_CODE_TYPE(state, payload) {
      state.typeOfCode = payload
    },
    UPDATE_REDIRECTION(state, payload) {
      state.isRedirected = payload
    },
    UPDATE_WIDGET_VISIBILITY(state, visibility) {
      state.widgetVisibility = visibility
    },
    UPDATE_MODAL_VISIBILITY(state, visibility) {
      state.actionModalVisibility = visibility
    },
    UPDATE_ACTION_COLUMN_VISIBILITY(state, visibility) {
      state.actionColumnVisibility = visibility
    },
    UPDATE_REANALYSIS_AUTH(state, visibility) {
      state.reanalysisAuthorization = visibility
    },
    UPDATE_PRIORIZATION_AUTH(state, visibility) {
      state.priorizationAuthorization = visibility
    },
    UPDATE_FINALIZATION_AUTH(state, visibility) {
      state.finalizationAuthorization = visibility
    },
    UPDATE_FINALIZATION_MENU_LIST(state, payload) {
      state.finalizationMenuList = payload
    },
    UPDATE_FINALIZATION_STATUS_ID(state, payload) {
      state.finalizationStatusList = payload
    },
    UPDATE_FINALIZATION_ALLOWENCE(state, payload) {
      state.finalizationAllowence = payload
    },
    UPDATE_FINALIZATION_STATUS_LOADING(state, payload) {
      state.finalizationStatusListLoading = payload
    },
    UPDATE_FINALIZATION_STATUS_ERROR(state, payload) {
      state.finalizationStatusError = payload
    },
    UPDATE_PRIORITIZE_LIST(state, payload) {
      state.prioritiesList = payload
    },
    UPDATE_REANALYSIS_LIST(state, payload) {
      state.reanalysisList = payload
    },
    UPDATE_REANALYSIS_ERROR(state, payload) {
      state.reanalysisError = payload
    },
    UPDATE_REANALYSIS_ID(state, payload) {
      state.reanalysisTypeId = payload
    },
    UPDATE_PRIORITIZE_ERROR_LIST(state, payload) {
      state.prioritiesErrorList = payload
    },
    UPDATE_REANALYSIS_ERROR_LIST(state, payload) {
      state.reanalysisErrorList = payload
    },
    UPDATE_ERROR_MODAL(state, payload) {
      state.actionModalError = payload
    },
    UPDATE_PRIORITIZE_ERROR(state, payload) {
      state.prioritiesError = payload
    },
    UPDATE_FINALIZATION_ERROR(state, payload) {
      state.finalizationError = payload
    },
    UPDATE_FINALIZATION_ERROR_MESSAGE(state, payload) {
      state.finalizationErrorMessage = payload
    },
    UPDATE_ACTION_LOADING(state, visibility) {
      state.actionsListLoading = visibility
    },
    UPDATE_FINALIZATION_LOADING(state, visibility) {
      state.finalizationMenuLoading = visibility
    },
    UPDATE_ACTION_RELOAD(state, payload) {
      state.actionUpdate = payload
    },
    HANDLE_REQUEST_LOADING(state, visibility) {
      state.isLoading = visibility
    }
  },
  getters: {
    getCodeToSearch(state) {
      return state.codeToSearch
    },
    getCodeType(state) {
      return state.typeOfCode
    },
    getOrdersList(state) {
      return state.info.orders
    },
    getOrdersCount(state) {
      return state.info.count
    },
    getReturnMessage(state) {
      if (state.typeOfCode === 'document') {
        if (state.codeToSearch.length > 11) {
          return `CNPJ: ${cnpj(state.codeToSearch)}`
        } else {
          return `CPF: ${cpf(state.codeToSearch)}`
        }
      } else {
        return `Código do pedido: ${state.codeToSearch}`
      }
    },
    getIsRedirected(state) {
      return state.isRedirected
    },
    getNoReturn(state) {
      return state.noReturn
    },
    getError(state) {
      return state.error
    },
    getCurrentPage(state) {
      return state.currentPage
    },
    getPageQuantity(state) {
      return state.pageQuantity
    },
    getModalVisibility(state) {
      return state.confirmationModal
    },
    getWidgetVisibility(state) {
      return state.widgetVisibility
    },
    getActionColumnVisibility(state) {
      return (
        state.reanalysisAuthorization ||
        state.priorizationAuthorization ||
        state.finalizationAuthorization
      )
    },
    getReanalysisAuth(state) {
      return state.reanalysisAuthorization
    },
    getPriorizationAuth(state) {
      return state.priorizationAuthorization
    },
    getFinalizationAuth(state) {
      return state.finalizationAuthorization
    },
    getFinalizationMenuList(state) {
      return state.finalizationMenuList
    },
    getFinalizationAllowence(state) {
      return state.finalizationAllowence
    },
    getActionModalVisibility(state) {
      return state.actionModalVisibility
    },
    getPrioritiesList(state) {
      return state.prioritiesList
    },
    getterReanalysisList(state) {
      return state.reanalysisList
    },
    getReanalysisTypeId(state) {
      return state.reanalysisTypeId
    },
    getPrioritiesErrorList(state) {
      return state.prioritiesErrorList
    },
    getReanalysisErrorList(state) {
      return state.reanalysisErrorList
    },
    getActionsLoading(state) {
      return state.actionsListLoading
    },
    getFinalizationMenuLoading(state) {
      return state.finalizationMenuLoading
    },
    getFinalizationStatusList(state) {
      return state.finalizationStatusList
    },
    getFinalizationStatusLoading(state) {
      return state.finalizationStatusListLoading
    },
    getFinalizationStatusError(state) {
      return state.finalizationStatusError
    },
    getPrioritiesError(state) {
      return state.prioritiesError
    },
    getReanalysisError(state) {
      return state.reanalysisError
    },
    getFinalizationError(state) {
      return state.finalizationError
    },
    getFinalizationErrorMessage(state) {
      return state.finalizationErrorMessage
    },
    getActionModalError(state) {
      return state.actionModalError
    },
    getActionUpdate(state) {
      return state.actionUpdate
    },
    getSnackbarVisibility(state) {
      return state.actionSnackbar
    },
    getSnackbarAction(state) {
      return state.actionSnackbarOption
    }
  },
  actions: {
    updateCodeToSearch({ commit }, params) {
      commit('UPDATE_CODE', params)
    },
    updateCodeType({ commit }, params) {
      commit('UPDATE_CODE_TYPE', params)
    },
    resetResults({ commit }) {
      commit('RESET_STATE')
      commit('UPDATE_ORDERS', {
        orders: []
      })
      commit('UPDATE_NO_RETURN', false)
    },
    toggleConfirmationModal({ commit }, params) {
      commit('TOGGLE_CONFIRMATION_MODAL', params)
    },
    updateRedirection({ commit }, params) {
      commit('UPDATE_REDIRECTION', params)
    },
    updateError({ commit }, params) {
      commit('UPDATE_ERROR', params)
    },
    updatePage({ commit }, params) {
      commit('UPDATE_PAGE', params)
    },
    updatePageQuantity({ commit }, params) {
      commit('UPDATE_PAGE_QUANTITY', params)
    },
    updateActionModalVisibility({ commit }, params) {
      commit('UPDATE_MODAL_VISIBILITY', params)
    },
    updateActionTableReload({ commit }, params) {
      commit('UPDATE_ACTION_RELOAD', params)
    },
    updateFinalizationError({ commit }, params) {
      commit('UPDATE_FINALIZATION_ERROR', params)
    },
    async getSearchOrdersValidation({ commit }, params) {
      const ordersSearchObjectName = 'OrderSearchScreen'
      commit('UPDATE_WIDGET_VISIBILITY', false)
      try {
        const data = await getAccessValidation(params, ordersSearchObjectName)
        commit('UPDATE_WIDGET_VISIBILITY', data.data.success)
      } catch (err) {
        if (err.response.status >= 400 && err.response.status < 500) {
          commit('UPDATE_WIDGET_VISIBILITY', false)
        }
      }
    },
    async getPriorizationValidation({ commit }, params) {
      const { entityLegacyId, objectName } = params

      try {
        const priorization = await getAccessValidation(
          entityLegacyId,
          objectName
        )

        const priorizationAuthorization = priorization.data.success

        commit('UPDATE_PRIORIZATION_AUTH', priorizationAuthorization)
      } catch (err) {
        if (err.response.status >= 400 && err.response.status < 500) {
          commit('UPDATE_PRIORIZATION_AUTH', false)
        }
      }
    },
    async getReanalysisValidation({ commit }, params) {
      const { entityLegacyId, objectName } = params

      try {
        const reanalysis = await getAccessValidation(entityLegacyId, objectName)
        const reanalysisAuthorization = reanalysis.data.success

        commit('UPDATE_REANALYSIS_AUTH', reanalysisAuthorization)
      } catch (err) {
        if (err.response.status >= 400 && err.response.status < 500) {
          commit('UPDATE_REANALYSIS_AUTH', false)
        }
      }
    },
    async getFinalizationValidation({ commit }, params) {
      const { entityLegacyId, objectName } = params

      try {
        const finalization = await getAccessValidation(
          entityLegacyId,
          objectName
        )
        const finalizationAuthorization = finalization.data.success

        commit('UPDATE_FINALIZATION_AUTH', finalizationAuthorization)
      } catch (err) {
        if (err.response.status >= 400 && err.response.status < 500) {
          commit('UPDATE_FINALIZATION_AUTH', false)
        }
      }
    },
    updateMenuLoading({ commit }, params) {
      commit('UPDATE_FINALIZATION_LOADING', params)
    },
    async getFinalizationStatusIdList({ commit }, params) {
      const { entityLegacyId, orderCode } = params
      commit('PREPARE_TO_CALL_FINALIZATION')
      commit('UPDATE_FINALIZATION_STATUS_LOADING', true)
      commit('UPDATE_FINALIZATION_STATUS_ERROR', false)
      commit('UPDATE_FINALIZATION_ALLOWENCE', false)

      try {
        const data = await getFinalizationStatusList(entityLegacyId, orderCode)
        commit('UPDATE_FINALIZATION_STATUS_ID', data.data.status)
        if (data.data.status.length > 0) {
          commit('UPDATE_FINALIZATION_ALLOWENCE', true)
        }
      } catch (err) {
        if (
          err.response.status >= 400 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          commit('UPDATE_FINALIZATION_STATUS_ERROR', true)
          commit('UPDATE_FINALIZATION_ERROR_MESSAGE', err.response.data)
        }
      } finally {
        commit('UPDATE_FINALIZATION_STATUS_LOADING', false)
      }
    },
    async getPrioritizeList({ commit }, params) {
      const { orderCode, entityLegacyId } = params
      commit('UPDATE_ACTION_LOADING', true)
      commit('UPDATE_PRIORITIZE_ERROR', false)
      commit('UPDATE_ERROR_MODAL', false)
      try {
        const data = await prioritizeList(orderCode, entityLegacyId)
        commit('UPDATE_PRIORITIZE_LIST', data.data)
      } catch (err) {
        if (
          err.response.status >= 400 &&
          err.response.status !== 403 &&
          err.response.status < 500
        ) {
          const errorObject = err.response.data
          commit('UPDATE_PRIORITIZE_ERROR_LIST', errorObject)
          commit('UPDATE_ERROR_MODAL', true)
        } else if(err.response.status === 503){
          commit('UPDATE_ERROR_MODAL', true)
          commit('UPDATE_PRIORITIZE_ERROR_LIST', {title: err.response.data.title, message: "Não é possível solicitar prioridade entre às 21:05 e às 08:30, pois a Operação está indisponível nesse período. Caso precise de assistência, por favor entre em contato conosco através dos canais:", channels: ['E-mail: central.relacionamento@clear.sale', 'Tel.: (11) 3728-8788 (opção 1, na sequência opção 1 novamente)', 'WhatsApp: (11) 93958-8480']})
        }
        else {
          commit('UPDATE_PRIORITIZE_ERROR', true)
          commit('UPDATE_PRIORITIZE_ERROR_LIST', errorObject)
        }
      } finally {
        commit('UPDATE_ACTION_LOADING', false)
      }
    },
    async getReanalysisList({ commit }, params) {
      const { orderCode, entityLegacyId } = params
      commit('UPDATE_ACTION_LOADING', true)
      commit('UPDATE_REANALYSIS_ERROR', false)
      commit('UPDATE_ERROR_MODAL', false)
      try {
        const data = await reanalysisList(orderCode, entityLegacyId)
        commit('UPDATE_REANALYSIS_LIST', data.data[0])
        commit('UPDATE_REANALYSIS_ID', data.data[0].typeId)
      } catch (err) {
        if (
          err.response.status >= 400 &&
          err.response.status !== 403 &&
          err.response.status < 500
        ) {
          const errorObject = err.response.data
          commit('UPDATE_REANALYSIS_ERROR_LIST', errorObject)
          commit('UPDATE_ERROR_MODAL', true)
        } else {
          commit('UPDATE_REANALYSIS_ERROR', true)
        }
      } finally {
        commit('UPDATE_ACTION_LOADING', false)
      }
    },
    async prioritizeOrderByParam({ commit }, params) {
      commit('UPDATE_SNACKBAR_ACTION', 'priorizar')
      const { orderCode, entityLegacyId, priorityTypeId } = params
      await prioritizeOrder(orderCode, entityLegacyId, priorityTypeId)
      commit('TOGGLE_ACTION_SNACKBAR')
    },
    async reanalyzeOrderByParam({ commit }, params) {
      commit('UPDATE_SNACKBAR_ACTION', 'reanalisar')
      const { orderCode, entityLegacyId, reanalisisTypeId } = params
      await reanalyzeOrder(orderCode, entityLegacyId, reanalisisTypeId)
      commit('TOGGLE_ACTION_SNACKBAR')
    },
    async finalizeOrderByParam({ commit }, params) {
      commit('UPDATE_FINALIZATION_STATUS_LOADING', true)

      try {
        commit('UPDATE_SNACKBAR_ACTION', 'finalizar')
        const { orderCode, entityLegacyId, finalizationTypeId } = params
        await finalizationByParam(entityLegacyId, orderCode, finalizationTypeId)
        commit('UPDATE_ACTION_RELOAD', true)
        commit('TOGGLE_ACTION_SNACKBAR')
      } catch (err) {
        commit('UPDATE_FINALIZATION_ERROR', true)
        commit('UPDATE_FINALIZATION_ERROR_MESSAGE', err.response.data)
      } finally {
        commit('UPDATE_FINALIZATION_STATUS_LOADING', false)
      }
    },
    async checkOrders({ commit }, params) {
      const { code, id, page, pageQuantity } = params
      commit('HANDLE_REQUEST_LOADING', true)
      try {
        const data = await getOrders(
          code,
          id,
          page,
          pageQuantity,
          configParameters.orderBy
        )
        if (data.status !== 200) {
          commit('UPDATE_NO_RETURN', true)
          commit('UPDATE_PAGE', 0)
        } else {
          return !!data.data.byOrderCode && data.data.byCpfCnpj
        }
      } catch (err) {
        commit('UPDATE_ERROR', true)
        commit('UPDATE_PAGE', 0)
      } finally {
        commit('HANDLE_REQUEST_LOADING', false)
      }
    },
    async getOrders({ commit }, params) {
      const { code, id, page, pageQuantity } = params
      commit('HANDLE_REQUEST_LOADING', true)
      commit('PREPARE_TO_CALL')
      commit('UPDATE_NO_RETURN', false)
      commit('UPDATE_CODE', code)
      try {
        const data = await getOrders(
          code,
          id,
          page,
          pageQuantity,
          configParameters.orderBy
        )
        if (data.status !== 200) {
          commit('UPDATE_NO_RETURN', true)
          commit('UPDATE_PAGE', 0)
        } else {
          if (data.data.byOrderCode) {
            commit('UPDATE_ORDERS_BY_CODE', [data.data.byOrderCode])
            commit('UPDATE_CODE_TYPE', 'code')
            commit('UPDATE_PAGE', page)
          } else {
            commit('UPDATE_ORDERS', data.data.byCpfCnpj)
            commit('UPDATE_CODE_TYPE', 'document')
            commit('UPDATE_PAGE', page)
          }
        }
      } catch (err) {
        commit('UPDATE_ERROR', true)
        commit('UPDATE_PAGE', 0)
      } finally {
        commit('HANDLE_REQUEST_LOADING', false)
      }
    }
  }
}
